module.exports = __webpack_public_path__ + "img/icon_gongneng5.2eda1cf0.svg";